// Portada premium oscura (Claude): modo claro/oscuro, selector de color/pack y fiambrera 3D en bucle.
const root = document.querySelector('[data-mt-hx]');
if (root) init(root);

function init(root) {
  const $ = (s) => root.querySelector(s);
  const $$ = (s) => Array.from(root.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const smooth = (a, b, v) => { const t = Math.min(1, Math.max(0, (v - a) / (b - a))); return t * t * (3 - 2 * t); };

  // Interruptor claro/oscuro (se recuerda en este navegador)
  const mode = $('[data-hx-mode]');
  const setLight = (on) => { root.classList.toggle('is-light', on); if (mode) mode.setAttribute('aria-checked', on ? 'true' : 'false'); };
  // Blanca por defecto; oscura solo si el cliente lo eligió
  let light = true;
  try { light = localStorage.getItem('nuve-claro') !== '0'; } catch (e) {}
  setLight(light);
  if (mode) mode.addEventListener('click', () => { const on = !root.classList.contains('is-light'); setLight(on); try { localStorage.setItem('nuve-claro', on ? '1' : '0'); } catch (e) {} });

  // Color y pack
  let api = null;
  const photo = $('[data-hx-photo]');
  $$('[data-hx-color]').forEach((b) => b.addEventListener('click', () => {
    $$('[data-hx-color]').forEach((x) => { x.classList.toggle('is-on', x === b); x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
    $$('[data-hx-prop]').forEach((i) => { i.value = b.dataset.hxName; });
    if (photo && b.dataset.hxImg) photo.src = b.dataset.hxImg;
    if (api) api.setLidColor(b.dataset.hxColor);
  }));
  const variant = $('[data-hx-variant]');
  $$('input[name="hx-pack"]').forEach((r) => r.addEventListener('change', () => {
    $$('.mt-hx__pack').forEach((l) => l.classList.toggle('is-on', l.contains(r) && r.checked));
    if (variant) variant.value = r.value;
    const two = $('[data-hx-prop="2"]');
    if (two) two.disabled = (parseInt(r.dataset.qty, 10) || 1) < 2;
  }));

  const canvas = $('[data-hx-canvas]');
  if (!canvas || !root.dataset.lib) return;
  // El 3D arranca en cuanto se ha pintado la imagen fija del tubo (que es idéntica), sin esperar al resto de la página
  requestAnimationFrame(() => setTimeout(() => start3d(canvas), 0));

  function start3d(canvas) {

  // Tubo de crema 3D: gira solo y, en bucle, se desenrosca el tapón, sale la crema y se vuelve a cerrar
  if (root.dataset.model === 'crema') {
    import(root.dataset.lib).then(({ mountTube }) => {
      api = mountTube(canvas, {
        brand: root.dataset.brand, line1: root.dataset.line1, line2: root.dataset.line2,
        accent: getComputedStyle(root).getPropertyValue('--hx-accent').trim() || '#D78C97',
        sway: .75, baseYaw: 0, fit: 12.5, lookAt: 0, float: .07
      });
      if (!api) return;
      // se muestra el 3D (con fundido) cuando ya ha pintado su primer fotograma
      requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add('is-3d')));
      const S = api.S;
      const CYCLE = 9; // s: reposo (0-1.6) · tapón fuera (1.6-2.6) · sale la crema (2.6-3.6) · vuelve (6.4-7.6)
      let tt = 0, last = performance.now();
      new IntersectionObserver((es) => { S.visible = es[0].isIntersecting ? 1 : 0; }, { threshold: 0 }).observe(canvas);
      (function tick(now) {
        const dt = Math.min(.1, (now - last) / 1000); last = now;
        if (!document.hidden && !reduce) tt = (tt + dt) % CYCLE;
        S.open = reduce ? 0 : smooth(1.6, 2.6, tt) * (1 - smooth(7, 7.9, tt));
        S.cream = reduce ? 0 : smooth(2.6, 3.6, tt) * (1 - smooth(6.3, 7, tt));
        requestAnimationFrame(tick);
      })(last);
    }).catch(() => {});
    return;
  }

  // Fiambrera 3D: gira sola y, en bucle, se calienta, abre la tapa con vapor y vuelve a cerrarse
  import(root.dataset.lib).then(({ mountLunchbox }) => {
    api = mountLunchbox(canvas, {
      brand: root.dataset.brand, lidColor: root.dataset.lid, bodyColor: root.dataset.body,
      rimColor: getComputedStyle(root).getPropertyValue('--hx-accent').trim() || '#D78C97',
      autoSpin: .32, baseYaw: -.5, fit: 8.4, lookAt: 1.05, float: .06, noShadow: true, steamRise: 1.8
    });
    if (!api) return;
    root.classList.add('is-3d');
    const S = api.S;
    const CYCLE = 9; // s: calentar (0-3) · tapa abierta con vapor (3-6.6) · cerrar (6.6-7.4) · reposo
    let tt = 0, last = performance.now();
    const io = new IntersectionObserver((es) => { S.visible = es[0].isIntersecting ? 1 : 0; }, { threshold: 0 });
    io.observe(canvas);
    (function tick(now) {
      const dt = Math.min(.1, (now - last) / 1000); last = now;
      if (!document.hidden && !reduce) tt = (tt + dt) % CYCLE;
      const heat = reduce ? .6 : smooth(0, 3, tt) * (1 - smooth(7.4, 8.8, tt));
      S.heat = heat;
      S.temp = Math.round(5 + heat * 55);
      S.lid = reduce ? 0 : smooth(3, 3.5, tt) * (1 - smooth(6.6, 7.4, tt));
      requestAnimationFrame(tick);
    })(last);
  }).catch(() => {});
  }
}
